/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_DiscountsInputs */

const en_admin_resource_form_discounts = /** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discounts`)
};

const de_admin_resource_form_discounts = /** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatte`)
};

const es_admin_resource_form_discounts = /** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuentos`)
};

const fr_admin_resource_form_discounts = /** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remises`)
};

const nl_admin_resource_form_discounts = /** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kortingen`)
};

/** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */
const it_admin_resource_form_discounts = en_admin_resource_form_discounts;

/** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_discounts = en_admin_resource_form_discounts;

/** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */
const pl_admin_resource_form_discounts = en_admin_resource_form_discounts;

/** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */
const hu_admin_resource_form_discounts = en_admin_resource_form_discounts;

/** @type {(inputs: Admin_Resource_Form_DiscountsInputs) => LocalizedString} */
const ro_admin_resource_form_discounts = en_admin_resource_form_discounts;

/**
* | output |
* | --- |
* | "Discounts" |
*
* @param {Admin_Resource_Form_DiscountsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_discounts = /** @type {((inputs?: Admin_Resource_Form_DiscountsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_DiscountsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_discounts(inputs)
	if (locale === "de") return de_admin_resource_form_discounts(inputs)
	if (locale === "es") return es_admin_resource_form_discounts(inputs)
	if (locale === "fr") return fr_admin_resource_form_discounts(inputs)
	if (locale === "nl") return nl_admin_resource_form_discounts(inputs)
	if (locale === "it") return it_admin_resource_form_discounts(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_discounts(inputs)
	if (locale === "pl") return pl_admin_resource_form_discounts(inputs)
	if (locale === "hu") return hu_admin_resource_form_discounts(inputs)
	return ro_admin_resource_form_discounts(inputs)
});
export { admin_resource_form_discounts as "admin.resource_form.discounts" }